import Alert from '@pelckmans/elementis/components/alert';
import Avatar from '@pelckmans/elementis/components/avatar';
import AvatarImage from '@pelckmans/elementis/components/avatar/avatar-image';
import Dialog from '@pelckmans/elementis/components/dialog';
import Heading from '@pelckmans/elementis/components/heading';
import { Dispatch, SetStateAction, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const BASE = 'PAGES.PROFILE.MODALS.SELECT_AVATAR.TABS.STANDARD.BODY';

interface Props {
  standardAvatar?: string;
  setStandardAvatar: Dispatch<SetStateAction<string | undefined>>;
  showAlert: boolean;
}

export default function StandardAvatarTab({ standardAvatar, setStandardAvatar, showAlert }: Props) {
  const { t } = useTranslation();

  const avatarMap = useMemo<Record<string, string>>(() => {
    const urlSuffixes = Array.from({ length: 9 }, (_, i) => String(i + 1).padStart(2, '0'));

    return ['default', ...urlSuffixes].reduce<Record<string, string>>((acc, avatarId) => {
      acc[avatarId] = `${process.env.PUBLIC_URL}/images/avatar/avatarimage_${avatarId}.jpg`;
      return acc;
    }, {});
  }, []);

  return (
    <Dialog.Body
      alertGroupProps={
        showAlert
          ? {
              'aria-label': undefined,
              role: undefined,
              children: <Alert prominence="danger">{t(`${BASE}.ALERT`)}</Alert>,
            }
          : undefined
      }
    >
      <fieldset>
        <legend>
          <Heading level={4} removeSpacing="all" className="modal-content-text-title">
            {t(`${BASE}.FORM.LABEL`)}
          </Heading>
        </legend>
        <div className="standard-avatars" role="radiogroup">
          {Object.entries(avatarMap).map(([id, url]) => (
            <Avatar
              id={url}
              radioProps={{ selected: standardAvatar, setSelected: setStandardAvatar, error: showAlert }}
              key={id}
            >
              <AvatarImage name={`avatar image ${id}`} size="xxxl" src={url} />
            </Avatar>
          ))}
        </div>
      </fieldset>
    </Dialog.Body>
  );
}
